// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "active" :
        return /* Active */0;
    case "inactive" :
        return /* Inactive */1;
    default:
      return ErrorUtils$Catalyst.raiseError("ServiceabilityStatus.re", "Invalid status", value);
  }
}

function toString(value) {
  if (value) {
    return "Inactive";
  } else {
    return "Active";
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  toString ,
  t_decode ,
  
}
/* No side effect */
